import { eventStatusOptions, schedulePrecisionOptions } from "../../labels";
import { type SubtypeSectionProps, subtypeControls } from "./support";
import { fieldGrid } from "../../components/styles";

export const eventFieldLabels = {
  venueName: "Venue",
  timeZone: "Event time zone",
  startsAt: "Starts",
  endsAt: "Ends",
  schedulePrecision: "Schedule precision",
  eventStatus: "Event status",
  ticketingNotes: "Ticketing notes",
} as const;

export function EventSection(props: SubtypeSectionProps) {
  const c = subtypeControls(props);
  return (
    <div className={fieldGrid}>
      {c.text("venueName", eventFieldLabels.venueName, { maxLength: 200 })}
      {c.text("timeZone", eventFieldLabels.timeZone, {
        required: true,
        hint: "An IANA name, for example Europe/Madrid. The times below are read in this zone.",
      })}
      {c.dateTime("startsAt", eventFieldLabels.startsAt, {
        required: true,
        hint: "Local time at the venue.",
      })}
      {c.dateTime("endsAt", eventFieldLabels.endsAt, {
        hint: "Local time at the venue. Optional.",
      })}
      {c.select("schedulePrecision", eventFieldLabels.schedulePrecision, schedulePrecisionOptions)}
      {c.select("eventStatus", eventFieldLabels.eventStatus, eventStatusOptions)}
      {c.area("ticketingNotes", eventFieldLabels.ticketingNotes, { rows: 3, maxLength: 1000 })}
    </div>
  );
}
